import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { useNavigate } from 'react-router';
import { pages } from '@/settings/pages';

export const PasswordResetSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const title = t('pages.password.reset.success.title');

  setTimeout(() => {
    navigate(pages.signin.index);
  }, 2000);

  return (
    <PageRootWrapper
      title={title}
      headerTitle={t('text.password.reset.success.prompt')}
      breadcrumbItems={[{ label: t('text.password.reset.success.prompt') }]}
      containerType="normal"
    >
      <p className="message">{t('text.password.reset.success.done')}</p>
    </PageRootWrapper>
  );
};
